import { useNavigate } from 'react-router';
import { useEffect, useRef } from 'react';
import { MAIN_ROUTE, Loader, useQueryParams, logger } from 'shared';
import { creditStore } from 'entities/credit';
import { userStore } from 'entities/user';
import { conversationStore } from 'entities/tavus/conversation/model/conversationStore';
import { tavusPersonaStore } from 'entities/tavus/persona';
import { TavusConference } from './TavusConference';

export const TavusCall = () => {
  const {
    startConversation,
    currentConversation,
    conversationLoading,
    conversationStarted
  } = conversationStore();

  const { currentPersona, fetchOne, setCurrentPersona } = tavusPersonaStore();
  const { user } = userStore();
  const { isChatAvailable } = creditStore();

  const nav = useNavigate();
  const params = useQueryParams();
  const language = params.get('language');
  const personaId = params.get('persona_id');
  const preconversationId = params.get('preconversation_id');

  useEffect(() => {
    if (personaId) {
      fetchOne(personaId).then((persona) => {
        if (persona) {
          setCurrentPersona(persona);
        } else {
          nav(MAIN_ROUTE);
        }
      });
    }
  }, [personaId]);

  const hasStartedRef = useRef(false);

  useEffect(() => {
    const readyToStart =
      user &&
      isChatAvailable &&
      currentPersona &&
      !conversationStarted &&
      !conversationLoading;

    if (readyToStart && !hasStartedRef.current) {
      hasStartedRef.current = true;
      startConversation({
        currentPersona,
        key: undefined,
        language: language || 'english',
        preconversationId
      })
        .then(() => {
          logger.debug('Conversation started');
        })
        .catch(() => {
          nav(MAIN_ROUTE);
        });
    }
  }, [
    user,
    isChatAvailable,
    currentPersona,
    conversationStarted,
    conversationLoading
  ]);

  useEffect(() => {
    if (!conversationLoading && !conversationStarted) {
      const shouldRedirect =
        (!currentPersona || !currentConversation) && !hasStartedRef.current;

      if (shouldRedirect) {
        nav(MAIN_ROUTE);
      }
    }
  }, [
    currentPersona,
    currentConversation,
    conversationLoading,
    conversationStarted
  ]);

  return (
    <div className="ag-w-full ag-h-[85vh] ag-relative ag-rounded-xl ag-overflow-hidden ag-bg-neutral-900 ag-flex ag-items-center ag-justify-center">
      {conversationLoading ? (
        <>
          <Loader size={96} />
        </>
      ) : (
        currentConversation && (
          <>
            <TavusConference />
          </>
        )
      )}
    </div>
  );
};
